import React from "react";
import "./index.css";

import SectionHeader from "../SectionHeader";

/*
    To edit the news item, you may change the contents I have labeled with
    "Update me!". Be careful not to remove any tags, such as <span>, etc.
    To add a new line, add <br />. For a new line with spacing, add two <br /><br />.
*/
const LatestNews = () => {
  return (
    <div className="latest-news">
      <SectionHeader>Latest News</SectionHeader>
      <div className="latest-news-box">
        <div className="latest-news-image">
          <img src="/images/ztz2.png" alt="Helicopter Flying Above Infantry, Captured By CWO-4 Huo" />
        </div>
        <div className="latest-news-body">
          <div className="latest-news-title">
            <span /*Update me!*/>Rank #45 Globally, #4 Europe, #1 UK!*</span>
          </div>
          <div className="latest-news-text">
            <span /*Update me!*/>
            The 5th Marine Regiment is proud to announce that we are now ranked #45 globally, #4 in Europe, and #1 in the UK on our Squad Server! This is a testament to the dedication and skill of our members, and we are grateful for their hard work and commitment. We will continue to strive for excellence and maintain our position as a top-tier squad server in the gaming community
            <br />
            <br />
            *As of 2026-17-10, based on the battlemetrics.com Squad Server Rankings.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
